(() => {
  'use strict';
  const app = document.getElementById('flieger-app');
  if (!app || app.dataset.initialized) return;
  app.dataset.initialized = 'true';
  const core = window.FliegerCore;
  const money = cents => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  let team;
  try { team = JSON.parse(app.dataset.team); } catch { team = { items: [] }; }
  const storageKey = 'aloe:team-test:v2:' + (team.handle || 'unassigned');
  const grid = document.getElementById('product-grid');
  const dialog = document.getElementById('cart-dialog');
  const lines = document.getElementById('cart-lines');
  const delivery = document.getElementById('test-delivery');
  const confirmation = document.getElementById('test-confirmation');
  let catalog = [], rows = [], receipt = null, timer;
  const node = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text !== undefined) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  const announce = text => {
    const toast = document.getElementById('toast');
    clearTimeout(timer);
    toast.textContent = text;
    toast.classList.add('visible');
    timer = setTimeout(() => toast.classList.remove('visible'), 3600);
  };
  const persist = () => {
    try { localStorage.setItem(storageKey, JSON.stringify(rows)); }
    catch { announce('Deine Auswahl bleibt für diesen Besuch erhalten. Speichern im Browser ist nicht möglich.'); }
  };
  const invalidateReceipt = () => {
    receipt = null;
    confirmation.hidden = true;
    lines.hidden = false;
  };
  function refreshTotals() {
    const totals = core.totals(rows, catalog, delivery.value);
    document.querySelector('[data-count]').textContent = totals.count;
    for (const key of ['subtotal', 'shipping', 'total', 'tax']) document.getElementById(key).textContent = money(totals[key]);
  }
  function update() {
    rows = core.normalize(rows, catalog);
    refreshTotals();
    lines.replaceChildren();
    for (const row of rows) {
      const product = catalog.find(p => p.id === row.id);
      const article = node('article', undefined, 'cart-line');
      const image = node('img');
      image.src = product.image;
      image.alt = product.name + ' – Test-Mockup';
      image.width = image.height = 84;
      const info = node('div', undefined, 'line-info');
      info.append(node('h3', product.name), node('p', product.color + ' · ' + row.size + ' · Druck inklusive'), node('p', money(product.price) + ' / Stück'));
      const controls = node('div', undefined, 'line-controls');
      const input = node('input');
      input.type = 'number'; input.min = '1'; input.max = '99'; input.step = '1'; input.value = row.qty;
      input.setAttribute('aria-label', 'Menge ' + product.name + ' ' + row.size);
      input.addEventListener('input', () => {
        const entered = Number(input.value);
        if (!Number.isInteger(entered) || entered < 1 || entered > 99) return;
        row.qty = entered;
        invalidateReceipt(); persist(); refreshTotals();
        article.querySelector('.line-price').textContent = money(product.price * row.qty);
      });
      input.addEventListener('change', () => {
        row.qty = core.quantity(input.value);
        invalidateReceipt(); persist(); update();
        const restored = Array.from(lines.querySelectorAll('input')).find(el => el.getAttribute('aria-label') === input.getAttribute('aria-label'));
        restored?.focus();
      });
      const remove = node('button', 'Entfernen', 'text-button');
      remove.type = 'button';
      remove.setAttribute('aria-label', product.name + ' ' + row.size + ' entfernen');
      remove.addEventListener('click', () => {
        rows = rows.filter(r => r !== row); invalidateReceipt(); persist(); update();
        dialog.querySelector('[data-close-cart]').focus();
      });
      controls.append(input, remove);
      info.append(controls);
      article.append(image, info, node('strong', money(product.price * row.qty), 'line-price'));
      lines.append(article);
    }
    if (!rows.length && !receipt) lines.append(node('p', 'Dein Testwarenkorb ist noch leer. Wähle zuerst einen Club-Artikel aus.', 'empty-cart'));
    document.getElementById('cart-summary').hidden = !rows.length || !!receipt;
  }
  function buildCard(product, index) {
    const card = node('article', undefined, 'product-card');
    card.dataset.product = product.id;
    const figure = node('div', undefined, 'product-image');
    const img = node('img');
    img.src = product.image; img.width = img.height = 1000; img.loading = 'lazy';
    img.alt = product.name + ' · ' + product.color + ' · illustratives Test-Mockup';
    figure.append(img, node('span', 'DRUCK INKLUSIVE', 'product-badge'));
    const body = node('div', undefined, 'product-body');
    body.append(node('span', (team.shortName || team.name) + ' / ' + String(index + 1).padStart(2, '0'), 'product-overline'), node('h3', product.name), node('p', product.description || '', 'product-description'));
    const color = node('p', undefined, 'color');
    color.append(document.createTextNode(product.color + ' · ' + (product.printPosition || 'Logo inklusive')));
    const price = node('p', undefined, 'price');
    price.append(node('strong', money(product.price)), node('span', ' / Stück'));
    body.append(color, price, node('p', 'Beispielpreis inkl. Druck & 19 % MwSt.', 'price-note'));
    const form = node('form', undefined, 'product-form');
    const field = node('div');
    const label = node('label', 'Größe');
    label.htmlFor = 'size-' + product.id;
    const select = node('select'); select.id = label.htmlFor; select.name = 'size'; select.required = true;
    const placeholder = node('option', 'Bitte wählen');
    placeholder.value = ''; placeholder.disabled = true; placeholder.selected = true;
    if (product.sizes.length > 1) select.append(placeholder);
    product.sizes.forEach(v => { const option = node('option', v.size); option.value = v.size; select.append(option); });
    field.append(label, select);
    const quantityField = node('div');
    const quantityLabel = node('label', 'Menge'); quantityLabel.htmlFor = 'quantity-' + product.id;
    const input = node('input'); input.id = quantityLabel.htmlFor; input.name = 'quantity'; input.type = 'number'; input.min = '1'; input.max = '99'; input.step = '1'; input.value = '1'; input.required = true;
    quantityField.append(quantityLabel, input);
    const add = node('button', 'In den Testwarenkorb  +', 'button');
    add.type = 'submit';
    form.append(field, quantityField, add);
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const size = select.value;
      if (!product.sizes.some(v => v.size === size)) return;
      const added = core.quantity(input.value);
      const existing = rows.find(r => r.id === product.id && r.size === size);
      if (existing && existing.qty + added > 99) { announce('Pro Größe sind im Test maximal 99 Stück möglich.'); return; }
      if (existing) existing.qty += added;
      else rows.push({ id: product.id, size, qty: added });
      invalidateReceipt(); persist(); update();
      announce(product.name + ' · ' + size + ' · ' + added + ' Stück hinzugefügt.');
    });
    body.append(form); card.append(figure, body);
    return card;
  }
  document.querySelector('[data-open-cart]').addEventListener('click', () => {
    update(); dialog.showModal(); document.body.classList.add('dialog-open');
  });
  document.querySelector('[data-close-cart]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => document.body.classList.remove('dialog-open'));
  delivery.addEventListener('change', () => { invalidateReceipt(); update(); });
  document.getElementById('test-checkout').addEventListener('click', () => {
    if (!rows.length) return;
    const totals = core.totals(rows, catalog, delivery.value);
    receipt = {
      type: 'SIMULATION_ONLY_NOT_AN_ORDER', reference: 'TEST-' + team.handle + '-' + Date.now(),
      team: team.name, createdAt: new Date().toISOString(),
      currency: 'EUR', pricesIn: 'cents', delivery: delivery.value, totals,
      items: rows.map(row => {
        const p = catalog.find(item => item.id === row.id), v = p.sizes.find(variant => variant.size === row.size);
        return { name: p.name, color: p.color, size: row.size, quantity: row.qty, grossUnitPrice: p.price, productId: p.productId, sku: v.sku, variantId: v.variantId, logo: p.motif, printPosition: p.printPosition, mockup: p.image };
      })
    };
    document.getElementById('test-result').textContent = totals.count + ' Artikel · ' + money(totals.total) + ' Test-Gesamtsumme. Referenz: ' + receipt.reference;
    confirmation.hidden = false; lines.hidden = true;
    document.getElementById('cart-summary').hidden = true;
    confirmation.focus();
  });
  document.getElementById('download-test').addEventListener('click', () => {
    if (!receipt) return;
    const url = URL.createObjectURL(new Blob([JSON.stringify(receipt, null, 2)], { type: 'application/json' }));
    const link = node('a'); link.href = url; link.download = receipt.reference + '.json';
    document.body.append(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  });
  document.getElementById('restart-test').addEventListener('click', () => {
    rows = []; invalidateReceipt(); persist(); update(); dialog.close(); announce('Bereit für einen neuen Test.');
  });
  Promise.resolve(team.items)
    .then(data => {
      if (!team.handle || !Array.isArray(data) || !data.length || data.length > 50) throw new Error('Missing team catalog');
      if (data.some(p => !p.id || !p.name || !Number.isSafeInteger(p.price) || p.price < 1 || !p.image || !Array.isArray(p.sizes) || !p.sizes.length || p.sizes.some(v => !v.size))) throw new Error('Invalid team item');
      catalog = data;
      try { rows = core.normalize(JSON.parse(localStorage.getItem(storageKey) || '[]'), catalog); } catch { rows = []; }
      grid.replaceChildren(...catalog.map(buildCard)); grid.setAttribute('aria-busy', 'false'); update();
    })
    .catch(() => {
      grid.replaceChildren(node('p', 'Die Testartikel konnten nicht geladen werden. Bitte lade die Seite erneut.', 'load-error'));
      grid.setAttribute('aria-busy', 'false');
    });
})();
